import { categories } from '@/mocks/categories';

export default function CategoryDirectory() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <span className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em]">
            Quick Access
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-2 leading-tight">
            Shop By Category
          </h2>
          <p className="text-base text-foreground-600 mt-1 max-w-lg">
            Browse Top Finds
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.href}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-start gap-3 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300/60 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-700 group-hover:bg-accent-200/80 group-hover:text-accent-800 transition-colors duration-200">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors duration-200">
                  {cat.name}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5">
                  Browse collection
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}